//  ----------------------------------------------------------------------------
//  Dependencies
//  ----------------------------------------------------------------------------
import { Button, IconButton, MenuItem, Modal as ModalTest, Select } from '@mui/material';
//  -- Components ---------------------
import { Close, CloseOutlined } from '@mui/icons-material';
// -- CSS ------------------------------
import './bingo.css';
//  -- Features -----------------------
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
//  -- Constants ----------------------

import { Snackbar, Alert } from '@mui/material';
import GradeModal from './GradeModal';
import AdminLoteria from './ListModals/AdminLoteria';
import MyLoteria from './ListModals/MyLoteria';
import DraftLoteriaList from './ListModals/DraftLoteriaList';
import AllTeachersBingo from './AllTeachersBingo';
import usePopUpAtOnce from 'components/hooks/usePopUpAtOnce';
import { Badge } from '@mui/material';
import SentryWrap from 'components/Sentry';

const ButtonContainers = styled.div`
  display: flex !important;
  align-items: center;
  flex-wrap: wrap;
  gap: 11px;
`;

const ModalContentDelete = styled.div`
  align-items: center;
  background-color: #112643;
  //   display: inline-flex;
  flex-direction: column;
  left: 50%;
  width: 83%;
  padding: 30px 16px 0px 16px;
  position: absolute;
  //   text-align: center;
  top: 50%;
  transform: translate(-50%, -50%);
  border-radius: 10px;
  @media (max-width: 600px) {
    width: 88%;
  }

  @media screen and (max-width: 900px) and (orientation: landscape) {
    overflow-y: auto;
    height: 300px;
  }
`;

//  ----------------------------------------------------------------------------
//  Feature
//  ----------------------------------------------------------------------------
//
//  Ebook
//
//  -- Description
//  Ebook display component
//
//  -- Props
//  ...
//
//  -- State
//  ...
//
//  -- Methods
//  ...
//
//  -- Usage
//  ...
//

const OneBingoModal = ({
  chapter,
  page,
  currentUser,
  currentClass,
  aiModal,
  setAiModal,
  setDraftId,
  showModalBingo = () => null,
  onPlayGame = () => null,
  onGameEdit = () => null,
  newMaskId = '',
  pageLearningModuleCount
}) => {
  const [modalVisible, setModalVisible] = useState(false);
  const [currentSection, setCurrentSection] = useState(1);

  const [playConfigModal, setPlayConfigModal] = useState(false);

  const [selectedGame, setSelectedGame] = useState({});
  const [redirectLoader, setRedirectLoader] = useState(false);
  const [gameInitLoader, setGameInitLoader] = useState(false);
  const [gameEditLoader, setGameEditLoader] = useState(false);
  const [alertSakeBar, setAlertSakeBar] = useState({
    open: false,
    message: '',
    severity: 'success',
  });
  const [gameTypeSelect, setGameTypeSelect] = useState('all');
  const {updatePopUpAtOnce} = usePopUpAtOnce();

  const handleCancel = () => {
    setModalVisible(false);
    setAiModal(false);
    setGameTypeSelect('');
    updatePopUpAtOnce(false);
    setCurrentSection(1);
  };

  useEffect(() => {
    if (!aiModal) return;
    if (currentUser?.role === 'teacher') {
      setCurrentSection(1);
    } else {
      setCurrentSection('my_game');
    }
  }, [currentUser, aiModal]);

  const showModal = (type) => {
    setCurrentSection(type ? type : 1);
    setModalVisible(true);
  };

  const closeAlert = () => {
    setAlertSakeBar({ ...alertSakeBar, open: false, message: '' });
  };
  const handleChange = (value) => {
    if (value == '1') {
      showModal(1);
    } else if (value == 'my_game') {
      showModal('my_game');
    } else if (value == 'draft') {
      showModal('draft');
    } else if (value == 'all_teachers') {
      showModal('all_teachers');
    } else {
      showModalBingo();
      handleCancel();
    }
  };

  const onLoteriaStart = async (game) => {
    setPlayConfigModal(true);
    setSelectedGame(game);
    handleCancel();
  };

  const onLoteriaEdit = async (game) => {
    setGameEditLoader(true);
    try {
      onGameEdit(game);
      
      setImmediate(() => {
        setGameEditLoader(false);
        handleCancel();
      });
    } catch (error) {
      setGameEditLoader(false);
    }
  };

  return (
    <SentryWrap>
      <Snackbar
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        open={alertSakeBar.open}
        autoHideDuration={3000}
        onClose={closeAlert}
      >
        <Alert
          onClose={() => {
            setAlertSakeBar({ open: false, message: '' });
          }}
          severity={alertSakeBar.severity}
        >
          <strong>ALERT:</strong> {alertSakeBar.message}
        </Alert>
      </Snackbar>
      <GradeModal
        playConfigModal={playConfigModal}
        setPlayConfigModal={setPlayConfigModal}
        currentUser={currentUser}
        currentClass={currentClass}
        onPlayGame={async (result) => {
          await onPlayGame(result);
        }}
        selectedGame={selectedGame}
        setSelectedGame={setSelectedGame}
      />
      <ModalTest
        open={aiModal || modalVisible}
        onClose={() => handleCancel()}
        // className={"gameOneMdl"}
        closeIcon={<CloseOutlined />}
      >
        <ModalContentDelete style={{ position: 'relative' }}>
          <IconButton
            onClick={() => handleCancel()}
            style={{ position: 'absolute', top: 0, right: 0 }}
          >
            <Close color="secondary" />
          </IconButton>
          <div>
            <div className="createBtnBingo">
              <ButtonContainers className="btnBingoGrp">
                {currentUser?.role === 'teacher' && (
                  <Badge
                  overlap="rectangular"
                  badgeContent={pageLearningModuleCount?.bingo_admin > 0 ? pageLearningModuleCount?.bingo_admin : undefined}
                  color="info"
                  variant="standard"
                >
                  <Button
                    variant="outlined"
                    color={'primary'}
                    onClick={() => {
                      showModal(1);
                    }}
                    className={`BtnSelectedoneBingo ${currentSection === 1 ? 'BtnSelectedoneGameFocusAfterClick' : 'BtnSelectedoneBingoFocus'}`}
                  >
                    One Way Created
                  </Button>
                </Badge>
                )}
                {/* <Button
                                    variant="outlined"
                                    color="primary"
                                    // onClick={() => { showModal('my_game') }}
                                    className={`BtnSelectedoneBingo ${currentSection === "4" ? "BtnSelectedoneBingoFocus" : ""}`}
                                >Classic Loterías</Button> */}
                <Badge
                  overlap="rectangular"
                  badgeContent={pageLearningModuleCount?.bingo_user > 0 ? pageLearningModuleCount?.bingo_user : undefined}
                  color="info"
                  variant="standard"
                >
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={() => {
                    showModal('my_game');
                  }}
                  className={`BtnSelectedoneBingo ${currentSection === 'my_game' ? 'BtnSelectedoneGameFocusAfterClick' : 'BtnSelectedoneBingoFocus'}`}
                >
                  My Lotería
                </Button>
                </Badge>
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={() => {
                    showModalBingo();
                    handleCancel();
                  }}
                  className={`BtnSelectedoneBingo ${currentSection === '3' ? 'BtnSelectedoneGameFocusAfterClick' : 'BtnSelectedoneBingoFocus'}`}
                >
                  Create Lotería
                </Button>
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={() => { showModal('all_teachers') }}
                  className={`BtnSelectedoneBingo ${currentSection === "all_teachers" ? "BtnSelectedoneGameFocusAfterClick" : "BtnSelectedoneBingoFocus"}`}
                >
                  Teachers Created
                </Button>
                {currentUser?.role === 'owe_admin' && (
                  <Button
                    variant="outlined"
                    color="primary"
                    onClick={() => showModal('draft')}
                    className={`BtnSelectedoneBingo ${currentSection === 'draft' ? 'BtnSelectedoneGameFocusAfterClick' : 'BtnSelectedoneBingoFocus'}`}
                  >
                    Draft
                  </Button>
                )}
              </ButtonContainers>
            </div>
            <div className="mb-8 showInMobile">
              <Select
                labelId="simple-select-label"
                id="simple-select"
                // value={selectedOption}
                style={{
                  backgroundColor: 'white',
                  width: '100%',
                  borderRadius: 8,
                  padding: '5px 12px',
                  marginTop: 15,
                }}
                onChange={(e) => {
                  handleChange(e.target.value);
                }}
                value={currentSection}
              >
                {currentUser?.role === 'teacher' && <MenuItem value="1">One Way Created </MenuItem>}
                {/* <MenuItem value="">Classic Loterías</MenuItem> */}
                <MenuItem value="my_game">My Lotería</MenuItem>
                <MenuItem value="Create 1games">Create Lotería</MenuItem>
                <MenuItem value="all_teachers">Teachers Created</MenuItem>
                <MenuItem value="draft">Draft</MenuItem>
              </Select>
            </div>
            {currentSection === 1 && (
              <div className="gmCollectionUpr" style={{ marginTop: 15 }}>
                <div className="gmCollection">
                  <AdminLoteria
                    bookId={chapter}
                    pageId={page}
                    startGame={async (e) => {
                      await onLoteriaStart(e);
                    }}
                    gameInitLoader={gameInitLoader}
                    gameType={gameTypeSelect}
                    newMaskId={newMaskId}
                  />
                </div>
              </div>
            )}
            {currentSection === 'draft' && (
              <div className="gmCollectionUpr" style={{ marginTop: 15 }}>
                <div className="gmCollection">
                  <DraftLoteriaList
                    bookId={chapter}
                    pageId={page}
                    onSelect={(loteria) => {
                      // handle selection of a draft loteria
                      setSelectedGame(loteria);
                      setPlayConfigModal(true);
                      setModalVisible(false);
                    }}
                    newMaskId={newMaskId}
                    onEditGame={(gameData) => {
                      setDraftId(gameData?.id);
                      onLoteriaEdit(gameData);
                    }}
                    gameEditLoader={gameEditLoader}
                  />
                </div>
              </div>
            )}

            {currentSection === 'my_game' && (
              <div className="gmCollectionUpr" style={{ marginTop: 15 }}>
                <div className="gmCollection">
                  <MyLoteria
                    bookId={chapter}
                    pageId={page}
                    startGame={async (e) => {
                      await onLoteriaStart(e);
                    }}
                    gameInitLoader={gameInitLoader}
                    onEditGame={(gameData) => {
                      setDraftId(null);
                      onLoteriaEdit(gameData);
                    }}
                    gameEditLoader={gameEditLoader}
                    gameType={gameTypeSelect}
                    newMaskId={newMaskId}
                  />
                </div>
              </div>
            )}

            {currentSection === 'all_teachers' && (
              <div className="gmCollectionUpr" style={{ marginTop: 15 }}>
                <div className="gmCollection">
                  <AllTeachersBingo
                    bookId={chapter}
                    pageId={page}
                    userId={currentUser?.id}
                    startGame={async (e) => {
                      await onLoteriaStart(e);
                    }}
                    gameInitLoader={gameInitLoader}
                    gameType={gameTypeSelect}
                    newMaskId={newMaskId}
                    onDuplicateGame={(gameData) => {
                      const bingoDataParsed = typeof gameData?.bingo_data === 'string' 
                        ? JSON.parse(gameData.bingo_data || '[]') 
                        : gameData?.bingo_data || [];
                      const configurations = {
                        ...gameData?.configurations,
                        bingo_type: gameData?.configurations?.bingo_type || gameData?.bingo_type,
                      };
                      const { id, created_by, user_id, ...restGameData } = gameData;
                      
                      const duplicatedGame = {
                        ...restGameData,
                        created_by: currentUser?.id, 
                        user_id: currentUser?.id, 
                        bingo_data: bingoDataParsed, 
                        configurations, 
                      };
                      
                      onLoteriaEdit(duplicatedGame);
                    }}
                    gameDuplicateLoader={gameEditLoader}
                  />
                </div>
              </div>
            )}
          </div>
        </ModalContentDelete>
      </ModalTest>
    </SentryWrap>
  );
};


export default OneBingoModal;
